import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const TenantFinderIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8336 10.8424C12.6388 9.76437 13.075 8.45557 13.0777 7.11008C13.0777 5.85073 12.7043 4.61966 12.0046 3.57254C11.3049 2.52543 10.3105 1.7093 9.147 1.22737C7.98351 0.745435 6.70324 0.619339 5.46808 0.865027C4.23293 1.11071 3.09837 1.71715 2.20787 2.60765C1.31737 3.49815 0.710934 4.63271 0.465246 5.86786C0.219559 7.10302 0.345654 8.38329 0.827588 9.54678C1.30952 10.7103 2.12565 11.7047 3.17276 12.4044C4.21988 13.104 5.45095 13.4775 6.7103 13.4775C8.11113 13.4775 9.39441 13.0073 10.4426 12.2334L14.0474 15.8284L15.4286 14.4472L11.8336 10.8424ZM6.7103 11.5183C4.2711 11.5183 2.3021 9.54929 2.3021 7.11008C2.3021 4.67088 4.2711 2.70188 6.7103 2.70188C9.14951 2.70188 11.1185 4.67088 11.1185 7.11008C11.1185 9.54929 9.14951 11.5183 6.7103 11.5183Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.71656 10.7605C8.73431 10.7605 10.37 9.12481 10.37 7.10707C10.37 5.08932 8.73431 3.45361 6.71656 3.45361C4.69882 3.45361 3.06311 5.08932 3.06311 7.10707C3.06311 9.12481 4.69882 10.7605 6.71656 10.7605ZM6.71426 4.38998L7.37463 6.42959H9.43095L7.75078 7.75867L8.39443 9.82335L6.71426 8.54442L5.0341 9.82335L5.67774 7.75867L3.99758 6.42959H6.0539L6.71426 4.38998Z"
        fill={fill || color || 'currentColor'}
      />
    </svg>
  )
}
